import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CommonTable from '../../CommonTable/CommonTable';
import TableAction from '../../CommonTable/TableAction';
import Loader from '../../Loader/Loader';

import { deleteBlogDetails, updateBlogStatus } from '../../../actions/siteadmin/deleteBlogDetails';
import { dynamicBlogValue } from '../../../helpers/GetDynamicItemName/dynamicHomeValue';

import CustomPagination from '../../CustomPagination/CustomPagination';
import cp from '../../../components/commonStyle.css';
import s from './BlogManagement.css';
import messages from '../../../locale/jsonMessages';


function BlogManagement(props) {

  const { loading, data, updateBlogStatus, deleteBlogDetails, refetch, currentPage, searchList, setStateVariable, } = props;
  const { formatMessage } = props.intl;

  const paginationData = (page) => {
    setStateVariable({ currentPage: page, searchList });
    refetch({ currentPage: page, searchList });
  };

  const handleSearchChange = (value) => {
    setStateVariable({ currentPage: 1, searchList: value });
    refetch({ currentPage: 1, searchList: value });
  };

  const handleDeleteLocation = async (id) => {
    let variables = { currentPage: currentPage > 1 && data?.results?.length == 1 ? currentPage - 1 : currentPage, searchList };
    setStateVariable({ currentPage: variables.currentPage, searchList });
    await deleteBlogDetails(id);
    refetch(variables);
  }

  const thead = () => {
    return [
      { data: formatMessage(messages.idLabel) },
      { data: formatMessage(messages.metaTitleLabel) },
      { data: formatMessage(messages.metaDescriptionLabel) },
      { data: formatMessage(messages.pageTitleLabel) },
      { data: formatMessage(messages.pageUrl) },
      { data: formatMessage(messages.footerCategoryLabel) },
      { data: formatMessage(messages.status) },
    ]
  };

  const tbody = () => {
    return data?.results?.map(value => {
      const { metaTitle, metaDescription, pageTitle } = dynamicBlogValue(value, props.intl.locale);
      return {
        id: value?.id,
        data: [
          { data: value?.id, },
          {
            data: <div className={cx(cp.displayFlex, cp.alignCenter, cp.spaceBetween)}>
              {metaTitle}
              <TableAction
                onClickDelete={() => handleDeleteLocation(value.id)}
                showDelete={true}
                showView={true}
                newLink={"/page/" + value.pageUrl}
                showEdit={true}
                editLink={"/siteadmin/edit/page/" + value.id}
              />
            </div>
          },
          { data: metaDescription },
          {
            data: pageTitle
          },
          { data: value?.pageUrl },
          { data: value?.footerCategory },
          {
            data: <div><a href="javascript:void(0)" onClick={() => updateBlogStatus(value?.id, value?.isEnable, currentPage, searchList)} >
              {value?.isEnable == 1 ? <FormattedMessage  {...messages.disableLabel} /> : <FormattedMessage  {...messages.enableLabel} />}
            </a></div>
          },
        ]
      }
    })
  }
  if (loading) {
    return <Loader type={"text"} />
  }
  return (
    <div>
      <CommonTable
        thead={thead}
        tbody={() => tbody()}
        isSearch
        onSearch={(e) => handleSearchChange(e?.target?.value)}
        title={formatMessage(messages.contentManagementLabel)}
        isLink
        href={`/siteadmin/page/add`}
        redirectionLabel={formatMessage(messages.addPageLabel)}
      />
      {data?.count > 0 && (
        <CustomPagination
          total={data?.count}
          currentPage={currentPage}
          defaultCurrent={1}
          defaultPageSize={10}
          change={paginationData}
          paginationLabel={formatMessage(messages.pagesLabel)}
        />
      )}
    </div>
  );
}

const mapState = (state) => ({});

const mapDispatch = {
  deleteBlogDetails,
  updateBlogStatus
};
BlogManagement.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    results: PropTypes.arrayOf(
      PropTypes.shape({
        metaTitle: PropTypes.string,
        metaDescription: PropTypes.string,
        pageTitle: PropTypes.string,
        pageUrl: PropTypes.string,
        footerCategory: PropTypes.string,
        isEnable: PropTypes.number,
        dynamicBlogDetails: PropTypes.arrayOf(
          PropTypes.shape({
            language: PropTypes.string,
            pageTitle: PropTypes.string,
            content: PropTypes.string,
            metaTitle: PropTypes.string,
            metaDescription: PropTypes.string,
          })
        ),
      })),
  }),
  deleteBlogDetails: PropTypes.any,
  updateBlogStatus: PropTypes.any,
};

BlogManagement.defaultProps = {
  data: []
};

export default injectIntl(withStyles(cp, s)(connect(mapState, mapDispatch)(BlogManagement)));